import "./ContactUs.scss";
import {useState} from "react";
import cogoToast from "cogo-toast";
import * as EmailValidator from "email-validator";
import {
    MDBBtn, MDBInput,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle, MDBTextArea
} from "mdb-react-ui-kit";
import Lottie from "react-lottie-player";
import lottieJson from "../../assets/success1.json";
import { useSelector, useDispatch } from 'react-redux'
import { hideModal } from '../../modalSlice'

const CancelIcon = "https://cdn.deepsense.space/Ripple/World/cancel-icon.png";

export const ContactUs = (props) => {
    // store
    const openModal = useSelector((state) => state.modal.open)
    const dispatch = useDispatch()
    // store

    const [formSubmitted, setFormSubmitted] = useState(false);
    const [name, setName] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [emailId, setEmailId] = useState("");
    const [organizationName, setOrganizationName] = useState("");
    const [message, setMessage] = useState("");


    const submitForm = () => {
        if(name === ""){
            cogoToast.error('Please fill name',{ position: 'top-center'});
        } else if(phoneNo === "") {
            cogoToast.error('Please fill phone number',{ position: 'top-center'});

        } else if(phoneNo.length < 10) {
            cogoToast.error('Please fill valid phone number',{ position: 'top-center'});

        } else if(EmailValidator.validate(emailId) === false) {
            cogoToast.error('Please fill valid email',{ position: 'top-center'});

        } else if(organizationName === "") {
            cogoToast.error('Please fill organization name',{ position: 'top-center'});

        } else if(message === "") {
            cogoToast.error('Please fill message',{ position: 'top-center'});

        } else {
            let data = {
                "name":name,
                "phone_number":phoneNo,
                "email":emailId,
                "organization_name":organizationName,
                "message":message
            }
            fetch('https://ripple-be.deepsense.dev/api/v1/contact_us', {
                method: 'post',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify(data)
            }).then(response => {
                return response.json();
            }).then(json => {
                if(json.message){
                    setName("");
                    setPhoneNo("");
                    setEmailId("");
                    setOrganizationName("");
                    setMessage("");
                    setFormSubmitted(true);
                }
            });
        }
    }
    return(
        <div>
            <MDBModal tabIndex='-1' show={openModal}
                      // setShow={dispatch(hideModal())}
                      staticBackdrop={true}
                      id={"contact-us-modal"}>
                <MDBModalDialog centered size='fullscreen-xl-down'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle style={{visibility:!formSubmitted ?'visible':'hidden'}}>Registration</MDBModalTitle>
                            <MDBBtn className='close-btn' color='none' onClick={() => dispatch(hideModal())}>
                                <img src={CancelIcon} alt={"CancelIcon"} width={"24px"}/>
                                <p className={"mobile-title mb-0"}>Fill the details</p>
                            </MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {
                                !formSubmitted ?
                                    <div>
                                        <div className={"form-content-section"}>
                                            <p className={"title mb-0"}>Improve Your Product Experience with</p>
                                            <p className={"sub-title"}>Ripple AR</p>
                                        </div>
                                        <MDBInput className='input-feild-section' type='text' id='form1Example1' label='Name' value={name} onChange={(e)=>setName(e.target.value)} />
                                        <MDBInput className='input-feild-section' type='number' id='form1Example2' label='Phone Number' value={phoneNo}  onChange={(event) => {
                                            if(event.target.value.length===11) return false;   //limits to 10 digit entry
                                            setPhoneNo(event?.target.value);       //saving input to state
                                        }
                                        }/>
                                        <MDBInput className='input-feild-section' type='email' id='form1Example1' label='Email' value={emailId} onChange={(e)=>setEmailId(e.target.value)}  />
                                        <MDBInput className='input-feild-section' type='text' id='form1Example2' label='Organization Name' value={organizationName} onChange={(e)=>setOrganizationName(e.target.value)} />
                                        <MDBTextArea className={'input-feild-section'} label='Message' id='textAreaExample' rows={8} cols={8} value={message} onChange={(e)=>setMessage(e.target.value)} />
                                        <MDBBtn className={"submit-btn d-flex justify-content-center align-items-center"}
                                                onClick={submitForm}
                                        >
                                            Submit
                                        </MDBBtn>

                                    </div>:
                                    <div className={"thankyou-section text-center"}>
                                        {/*<img src={SuccessIcon} alt={"SuccessIcon"} className={"img-fluid"}/>*/}
                                        <Lottie
                                            loop
                                            animationData={lottieJson}
                                            play
                                            // style={{ width: 150, height: 150 }}
                                        />
                                        <p className={"content"}>Thanks!
                                            For your response</p>
                                    </div>
                            }

                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
    )
}
